import styled from 'styled-components';

export const ScoreExplainablityContainer = styled.div`

  background: #fff;
  border-radius: 5px;
  padding: 14px 8px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  font-size: 14px;

  .header {
    padding:'2em 1em'
  }

  .widgitsView {
    font-size: 12px;
    white-space: nowrap;
  }

  .ant-collapse-header {
    background-color: #F7F7F8;
    border-radius : 10px; 
    align-items: center;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        border-top: 1px solid #d5dee7;
        border-bottom: 1px solid #d5dee7;
        border-left: 1px solid #d5dee7;
        background: #eef4fa;
        vertical-align: top;
        font-size: 12px;
        font-weight: 500;
        font-style: normal;
        line-height: 12px;
        color: #556069;
      }
    }
  }

  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.75rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        color: #556069;
      }
  }

`;

export const PreventionContainer = styled.div`
  padding: 30px;
`;

export const PreventionAlertHistoryContainer = styled.div`
background: #fff;
border-radius: 5px;
padding: 20px 20px;
margin-bottom: 24px;
box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
font-size: 14px;

.ant-table-thead th {
  vertical-align: top;
  background-color: #eef4fa;
  white-space: nowrap;
  padding: 8px 0 8px 16px;
  font-size: 12px;
  text-align:left;
  color:#748AA1;
  font-weight:bold;
  text-wrap: balance;
  }

  .ant-table-thead > tr:not(:last-child) > th[colspan]{
    text-align:left;
    font-weight:bold;
    color:#748AA1;
    font-size:12px;
  }

  .ant-table-thead:first-child > th {
    text-align:left;
  }

  .ant-table-cell{
    border: 1px solid #e8e8e8;
  }
}

`;

export const TableViewContainer = styled.div`
  .ant-table-pagination.ant-pagination {
    margin: 16px 0;
    color: #8e8e8e;

    li {
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 4px;
      line-height: 30px;

      svg {
        margin-bottom: 6px;
      }
    }

    .ant-pagination-total-text {
      padding: 3px;
      border: none;
    }
  }
`;

export default {
  plrtb: { padding: '2em 1em' },

  styleHighMedLow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },

  styleContainer: {
    background: '#fff',
    fontSize: '12px',
    borderRadius: '5px',
    padding: '15px 9px',
    marginBottom: '24px',
    boxShadow: '1px 1px 2px rgb(0 0 0 / 25%'
  },

  styleCustomPanel: {
    marginBottom: 24,
    border: 0,
    overflow: 'hidden'
  },

  panelHeading: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    display: 'inline-flex',
    width: '80%'
  }
};

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
`;
